import "./services/faro";
import { pushFaroError } from "./services/faro";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { ErrorBoundary } from "react-error-boundary";

import TimeAgo from "javascript-time-ago";

import en from "javascript-time-ago/locale/en";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { SocketProvider } from "./context/SocketProvider";
import { ReportProvider } from "./context/report";

TimeAgo.addDefaultLocale(en);

const root = ReactDOM.createRoot(document.getElementById("root"));

let persistor = persistStore(store);

function onReactError(error, info) {
  pushFaroError(error, { componentStack: info.componentStack });
}

root.render(
  <React.StrictMode>
    <ErrorBoundary
      onError={onReactError}
      fallback={<div>Something went wrong. Please refresh the page.</div>}
    >
      <Provider store={store}>
        <ReportProvider>
          <PersistGate loading={null} persistor={persistor}>
            <SocketProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/*" element={<App />} />
                </Routes>
              </BrowserRouter>
            </SocketProvider>
          </PersistGate>
        </ReportProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
